<template>
  <div class="chat-interface">
    <!-- 聊天消息区域 -->
    <div class="messages-container" ref="messagesContainer">
      <!-- 欢迎页面 -->
      <div v-if="isWelcome && messages.length === 0">
        <welcome-page v-if="isWelcome && messages.length === 0" @hint-selected="handleHintSelected" />
      </div>

      <!-- 对话消息 -->
      <chat-message v-for="(message, index) in messages" :key="index" :content="message.content"
        :isUser="message.isUser" :timestamp="message.timestamp" :images="message.images || []"
        :diseaseData="message.diseaseData" :cropName="message.cropName" @show-full-image="showImagePreview" 
        @crop-selected="(crop) => handleCropSelected(crop, message)" />
      <!-- 加载动画 -->
      <div v-if="isLoading" class="loading-animation">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div>

    <!-- 输入区域 -->
    <div class="input-area">
      <div class="input-container">
        <!-- 样例图片 -->
        <div class="sample-images">
          <div v-for="(image, index) in localizedSampleImages" :key="index" class="sample-image">
            <div class="image-wrapper" @click="handleSampleImage(image)">
              <img :src="image.preview" alt="样例" />
            </div>
            <div class="sample-image-text">
              <p>{{ image.displayName }}</p>
            </div>
          </div>
        </div>
        <!-- 输入框 -->
        <div class="input-textarea">
          <!-- 上传图片预览 -->
          <div class="image-preview" v-if="uploadedImages.length">
            <div v-for="(image, index) in uploadedImages" :key="index" class="preview-item">
              <img :src="image.preview" alt="预览" />
              <button class="remove-image" @click="removeImage(index)">
                <img src="@/assets/icons/remove.png" alt="" />
              </button>
            </div>
          </div>
          <textarea ref="messageInput" v-model="userMessage"
            :placeholder="$t('chat.placeholder')" class="message-input"
            @keydown.enter="sendMessage" @input="adjustTextareaHeight"></textarea>
          <div class="input-actions">
            <!-- <div class="input-actions-left">
              <button @click="toggleDeepThinking" :class="{ 'active': deepThinkingEnabled }">
                <img :src="require(`@/assets/icons/deepthink${deepThinkingEnabled ? '1' : '0'}.png`)" alt="深度思考"
                  class="button-icon" />
                <p>深度思考</p>
              </button>
              <button @click="toggleOnlineSearch" :class="{ 'active': onlineSearchEnabled }">
                <img :src="require(`@/assets/icons/online${onlineSearchEnabled ? '1' : '0'}.png`)" alt="深度思考"
                  class="button-icon" />
                <p>联网搜索</p>
              </button>
            </div> -->
            <div class="input-actions-right">
              <CustomTooltip :content="$t('chat.upload')">
                <button class="upload-button" @click="triggerImageUpload" :disabled="isProcessing">
                  <img src="@/assets/icons/imageUpload.png" alt="">
                </button>
              </CustomTooltip>
              <input type="file" ref="fileInput" accept="image/*" multiple style="display: none"
                @change="handleImageUpload" />
              <CustomTooltip :content="$t('chat.clear')">
                <button class="clear-button" @click="clearInput" :disabled="isProcessing">
                  <img src="@/assets/icons/clear.png" alt="">
                </button>
              </CustomTooltip>
              <CustomTooltip :content="$t('chat.send')">
                <button class="send-button" @click="sendMessage" :disabled="!canSendMessage || isProcessing">
                  <img src="@/assets/icons/send.png" alt="">
                </button>
              </CustomTooltip>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 图片预览弹窗 -->
    <div class="image-modal" v-if="previewImage" @click="closeImagePreview">
      <div class="modal-content">
        <img :src="previewImage" alt="预览" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.chat-interface {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}

.messages-container {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

/* 加载动画样式 */
.loading-message {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loading-animation {
  display: flex;
  justify-content: center;
  margin-top: 8px;
}

.dot {
  width: 8px;
  height: 8px;
  margin: 0 4px;
  background-color: #249745;
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out both;
  vertical-align: middle;
}

.dot:nth-child(1) {
  animation-delay: -0.32s;
}

.dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounce {

  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}

.input-area {
  width: 100%;
  max-width: 879px;
  margin: 0 auto 28px;
  padding: 0 20px;
  box-sizing: border-box;
}

.image-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.preview-item {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
}

.preview-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.remove-image {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  font-size: 14px;
  background-color: transparent;
}

.input-container {
  /* display: flex; */
  background-color: transparent;
  overflow: hidden;

}

.sample-images {
  display: flex;
  flex-wrap: wrap;
  gap: 17px;
  margin-bottom: 10px;
  margin-left: 60px;
  background-color: transparent;
}

.sample-image {
  position: relative;
  width: 75px;
  height: 75px;
  overflow: hidden;
  line-height: 0;
  font-size: 0;
  border-radius: 10px;
  border: 1px solid #249745;
}

.image-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
}

.image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 50% 50%;
  min-width: 100%;
  min-height: 100%;
}

.sample-image-text {
  /* 文字居中 */
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  /* 半透明黑色背景 */
  color: white;
  padding: 4px 2px;
  text-align: center;
  z-index: 2;
  /* 确保文字在图片之上 */

  /* 文字溢出处理 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sample-image-text p {
  width: 100%; /* Allow full width of parent */
  padding: 0 4px; /* Add padding */
  height: 17px;
  font-weight: 400;
  font-size: 11px; /* Slightly smaller for fitting */
  color: #FFFFFF;
  line-height: 17px;
  text-align: center; /* Center text */
  font-style: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}

.input-textarea {
  width: 100%;
  /* height: 144px; */
  border: 1px solid #e0e0e0;
  background-color: #FFFFFF;
  border-radius: 20px;
  padding: 20px 20px 23px 20px;
  box-sizing: border-box;
}

.message-input {
  width: 100%;
  min-height: 46px;
  max-height: 140px;
  overflow-y: auto;
  border: none;
  resize: none;
  outline: none;
  background-color: transparent;
  font-weight: 400;
  font-size: 16px;
  color: #303030;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  box-sizing: border-box;
}

.message-input::placeholder {
  color: #9A9A9A;
}

.input-actions {
  height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 27px;
}

.input-actions-left {
  display: flex;
  flex-direction: row;
  gap: 14px;
}

.input-actions-left button {
  background-color: #FFFFFF;
  width: 90px;
  height: 30px;
  border-radius: 15px;
  border: 1px solid #CECECE;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.input-actions-left p {
  font-weight: 400;
  font-size: 12px;
  color: #303030;
  line-height: 17px;
  transition: color 0.2s ease;
}

.input-actions-left button.active {
  border-color: #008626;
}

.input-actions-left button.active p {
  color: #008626;
}

.deepseek-icon {
  width: 14px;
  height: 14px;
}

.upload-button,
.clear-button {
  margin-right: 20px;
  border: none;
  background-color: transparent;
}

.upload-button img,
.clear-button img {
  width: 18px;
  height: 18px;
}



.send-button {
  padding: 8px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  border-radius: 4px;
}

.upload-button:hover,
.send-button:hover {
  background-color: #e0e0e0;
}

.send-button {
  margin-top: auto;
  width: 36px;
  height: 36px;
  background: rgba(21, 128, 61, 0.09);
  border-radius: 50%;
}

.send-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.input-tips {
  margin-top: 8px;
  text-align: right;
  font-size: 12px;
  color: #999;
}

.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  max-width: 90%;
  max-height: 90%;
}

.modal-content img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.button-icon {
  width: 16px;
  height: 16px;
  margin-right: 5px;
  vertical-align: middle;
}

.el-button.active {
  background-color: #e6f7ff;
  border-color: #1890ff;
  color: #1890ff;
}

.crop-options {
  margin-top: 10px;
}

.option-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 8px;
}

.crop-button {
  padding: 6px 12px;
  background-color: #249745;
  color: white;
  border: none;
  border-radius: 15px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.crop-button:hover {
  background-color: #1b7035;
}
</style>

<script>
import WelcomePage from './WelcomePage.vue';
import ChatMessage from './ChatMessage.vue';
import CustomTooltip from '@/components/CustomTooltip.vue';
// 导入两个API函数
import { predictDisease, cropDiagnosis } from '@/api/chat.js';

export default {
  name: 'ChatInterface',
  components: {
    ChatMessage,
    WelcomePage,
    CustomTooltip
  },
  data() {
    return {
      isLoading: false,
      diseaseData: {
        diseaseName: '',
        confidences: [],
        description: '',
        feature: '',
        method: '',
      },
      // 默认为true,有对话后变为false
      isWelcome: true,
      messages: [],
      userMessage: '',
      uploadedImages: [],
      previewImage: null,
      isProcessing: false,
      defaultCrop: '',
      deepThinkingEnabled: false,
      onlineSearchEnabled: false,
      sampleImages: [
        {
          preview: require('@/assets/image/testImage/corn/5.jpg'),
          key: 'corn'
        },
        {
          preview: require('@/assets/image/testImage/cotton/tjb.jpg'),
          key: 'cotton'
        },
        {
          preview: require('@/assets/image/testImage/pepper/IMG20220630093646.jpg'),
          key: 'pepper'
        },
        {
          preview: require('@/assets/image/testImage/peony/peony.png'),
          key: 'peony'
        },
        {
          preview: require('@/assets/image/testImage/rice/健康.jpg'),
          key: 'rice'
        },
        {
          preview: require('@/assets/image/testImage/tomato/2022-03-08 115305.jpg'),
          key: 'tomato'
        },
        {
          preview: require('@/assets/image/testImage/wheat/叶锈病.jpg'),
          key: 'wheat'
        }
      ],
      supportedCrops: ['番茄', '黄瓜', '苹果', '水稻', '葱', '大豆', '辣椒', '柑橘', '玉米']
    }
  },
  created() {
    // 示例数据用于测试
  },
  computed: {
    canSendMessage() {
      return (this.userMessage.trim() || this.uploadedImages.length > 0);
    },
    localizedSampleImages() {
      return this.sampleImages.map(img => ({
        ...img,
        displayName: this.$t(`chat.sampleImages.${img.key}`)
      }));
    }
  },
  mounted() {
    // 初始化时不添加消息，保持欢迎页显示
  },
  methods: {
    handleHintSelected(title) {
      // 自动填充输入框
      this.userMessage = title;
      // 立即发送请求
      this.$nextTick(() => {
        this.sendMessage();
      });
    },
    async handleSampleImage(image) {
      this.isLoading = true;
      try {
        // 获取图片二进制数据
        const response = await fetch(image.preview)
        if (!response.ok) throw new Error(`HTTP错误 ${response.status}`)

        // 生成Blob URL
        const blob = await response.blob()
        const imageUrl = URL.createObjectURL(blob)

        // 如果是棉花图片，显示模拟数据
        if (image.key === 'cotton') {
          // 创建模拟的棉花炭疽病数据
          const mockCottonResult = {
            cropName: this.$t('chat.sampleImages.cotton'),
            data: {
              data: [{
                label: this.$t('app.cottonModal.title'),
                confidences: [{
                  label: this.$t('app.cottonModal.title'),
                  confidence: 0.95 // 95%的置信度，对应"极大概率"
                }]
              }]
            },
            feature: this.$t('app.cottonModal.feature'),
            physics: this.$t('app.cottonModal.physics').replace(/<br>/g, '\n'),
            chemistry: this.$t('app.cottonModal.chemistry').replace(/<br>/g, '\n'),
            biology: this.$t('app.cottonModal.biology').replace(/<br>/g, '\n')
          };

          // 在对话框中显示棉花炭疽病结果
          this.addMessage('', false, [imageUrl], mockCottonResult);
          this.isLoading = false;
          return;
        }

        // 如果是牡丹图片，显示模拟数据
        if (image.key === 'peony') {
          // 创建模拟的牡丹缺铁黄叶病数据
          const mockPeonyResult = {
            cropName: this.$t('chat.sampleImages.peony'),
            data: {
              data: [{
                label: this.$t('app.peonyModal.title'),
                confidences: [{
                  label: this.$t('app.peonyModal.title'),
                  confidence: 0.88 // 88%的置信度，对应"大概率"
                }]
              }]
            },
            feature: this.$t('app.peonyModal.feature'),
            physics: this.$t('app.peonyModal.physics').replace(/<br>/g, '\n'),
            chemistry: this.$t('app.peonyModal.chemistry').replace(/<br>/g, '\n'),
            biology: this.$t('app.peonyModal.biology').replace(/<br>/g, '\n')
          };

          // 在对话框中显示牡丹缺铁黄叶病结果
          this.addMessage('', false, [imageUrl], mockPeonyResult);
          this.isLoading = false;
          return;
        }

        // 其他图片调用真实的诊断接口
        const imageFile = new File([blob], `${image.displayName}.jpg`, { type: 'image/jpeg' })
        // Pass language 'zh' or 'en'
        const result = await predictDisease(imageFile, image.displayName, this.$i18n.locale)

        // 传递生成的Blob URL
        this.addMessage('', false, [imageUrl], result)
        // 等待前面语句全部执行完再执行this.isLoading = false
        this.$nextTick(() => {
          this.isLoading = false;
        })

      } catch (error) {
        console.error('样例图片处理失败:', error)
        this.addMessage(`加载失败: ${error.message}`, false)
        this.isLoading = false;
      } finally {
        this.isProcessing = false;
      }
    },

    // 处理诊断响应的方法
   async handleDiagnosticResponse(response, imageBlob, cropName, imageUrl) {
      const { type, content, crop } = response;

      switch (type) {
        case 'image':
          if (crop) {
            const cropOptions = crop.split(' ').filter(Boolean);
            if (cropOptions.length > 0) {
              // Create crop options message using localized string
              let optionsHtml = `<div class="crop-options"><p>${this.$t('chat.cropSelectPrompt')}</p><div class="option-buttons">`;
              
              cropOptions.forEach(crop => {
                optionsHtml += `<button class="crop-button" data-crop="${crop}">${crop}</button>`;
              });
    
              optionsHtml += '</div></div>';
              
              this.addMessage(`${content}\n${optionsHtml}`, false);
              
              // 将图片数据绑定到最新的一条消息上，供后续点击按钮使用
              const lastMessage = this.messages[this.messages.length - 1];
              if (lastMessage) {
                lastMessage.relatedImageBlob = imageBlob;
                lastMessage.relatedImageUrl = imageUrl;
              }
            } else {
              this.addMessage(content, false);
            }
          } else {
            this.addMessage(content, false);
          }

          this.isLoading = false;

          break;

        case 'predict':
          // 需要调用专业模型进行分析
          if (imageBlob) {
            try {
              // 使用返回的作物名称和原始图片调用predictDisease, pass language
              const imageFile = new File([imageBlob], `${cropName}.jpg`, { type: 'image/jpeg' });
              const result = await predictDisease(imageFile, crop || cropName, this.$i18n.locale);
              this.addMessage(content, false, imageUrl ? [imageUrl] : [], result);
              this.isLoading = false;
            } catch (error) {
              console.error('专业分析失败:', error);
              this.addMessage(`专业分析请求失败: ${error.message}`, false);
              this.isLoading = false;
            }
          } else {
            // 没有图片的情况，只能显示初步分析结果
            this.addMessage(`${content}（无法进行专业分析，请上传图片）`, false);
            this.isLoading = false;
          }
          break;

        case 'error':
          // 错误信息，直接显示
          this.addMessage(content, false);
          this.isLoading = false;
          break;

        case 'answer':
          // 直接回答内容，显示
          this.addMessage(content, false);
          this.isLoading = false;
          break;

        default:
          // 未知类型，显示原始内容
          this.addMessage('收到未知类型的响应：' + content, false);
          this.isLoading = false;
      }
    },

    async handleCropSelected(selectedCrop, message) {
      // 从消息对象中获取关联的图片数据
      const imageBlob = message.relatedImageBlob;
      const imageUrl = message.relatedImageUrl;
      
      if (!imageBlob) {
        console.error('未找到关联的图片数据');
        return;
      }

      this.isLoading = true;
      
      try {
        // 创建File对象并调用预测, pass language
        const imageFile = new File([imageBlob], `${selectedCrop}.jpg`, { type: 'image/jpeg' });
        const result = await predictDisease(imageFile, selectedCrop, this.$i18n.locale);
        this.addMessage('', false, imageUrl ? [imageUrl] : [], result);
      } catch (error) {
        console.error('作物预测失败:', error);
        this.addMessage(`作物预测失败: ${error.message}`, false);
      } finally {
        this.isLoading = false;
      }
    },

    toggleDeepThinking() {
      this.deepThinkingEnabled = !this.deepThinkingEnabled;
      console.log('深度思考模式:', this.deepThinkingEnabled ? '开启' : '关闭');
    },
    toggleOnlineSearch() {
      this.onlineSearchEnabled = !this.onlineSearchEnabled;
      console.log('联网搜索模式:', this.onlineSearchEnabled ? '开启' : '关闭');
    },

    addMessage(content, isUser, images = [], diseaseData = null, cropName = null) {
      // 添加消息时将isWelcome设置为false
      this.isWelcome = false;

      this.messages.push({
        content,
        isUser,
        timestamp: Date.now(),
        images,
        diseaseData,
        cropName
      });

      // 等待DOM更新后再滚动
      this.$nextTick(() => {
        setTimeout(() => {
          // 用户发送消息时立即滚动到底部，AI回复时滚动到新消息顶部
          if (isUser) {
            const container = this.$refs.messagesContainer;
            if (container) {
              container.scrollTop = container.scrollHeight;
            }
          } else {
            this.scrollToBottom();
          }
        }, 100); // 添加小延时确保内容完全渲染
      });
    },

    // 将图片转换为Base64格式
    async imageToBase64(imageUrl) {
      try {
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      } catch (error) {
        console.error('图片转Base64失败:', error);
        return null;
      }
    },

    async sendMessage() {
      if (!this.canSendMessage || this.isProcessing) return;

      this.isLoading = true;
      const messageText = this.userMessage.trim();
      const imageUrls = this.uploadedImages.map(img => img.preview);

      // 添加用户消息
      this.addMessage(messageText, true, imageUrls);

      this.isProcessing = true;
      try {
        // 准备对话历史数据
        const history = [];

        // {
        //   role: "user",
        //   content: []
        // }

        for (const message of this.messages) {
          if (message.images[0] && message.images[0].includes('blob:')) {
            message.images[0] = await this.imageToBase64(message.images[0]);
          }
          if (message.isUser) {
            if (message.content && message.images[0]) {
              history.push({
                role: "user",
                content: [
                  {
                    type: "text",
                    text: message.content
                  },
                  {
                    type: "image_url",
                    image_url: {
                      url: message.images[0]
                    }
                  }
                ]
              });
            } else if (message.content) {
              history.push({
                role: "user",
                content: [
                  {
                    type: "text",
                    text: message.content
                  }
                ]
              });
            } else if (message.images[0]) {
              history.push({
                role: "user",
                content: [
                  {
                    type: "image_url",
                    image_url: {
                      url: message.images[0]
                    }
                  }
                ]
              });
            }

          } else {
            if (message.content) {
             history.push({
                role: "assistant",
                content: [
                  {
                    type: "text",
                    text: message.content
                  }
                ]
              }); 
            }
          }
        }

        // Pass language param
        const diagnosticResult = await cropDiagnosis(history, false,this.$i18n.locale);

        // 添加图片内容
        if (this.uploadedImages.length > 0) {
          await this.handleDiagnosticResponse(
            diagnosticResult,
            this.uploadedImages[0].file,
            messageText,
            this.uploadedImages[0].preview
          );
        } else {
          // 使用同样的响应处理逻辑
          await this.handleDiagnosticResponse(diagnosticResult, null, messageText, null).then(() => {
            this.isLoading = false;
          });
        }
      } catch (error) {
        console.error('对话请求失败:', error);
        this.addMessage(`请求失败: ${error.message || '网络错误'}，请稍后重试。`, false);
        this.isLoading = false;
      } finally {
        // 清空输入
        this.userMessage = '';
        this.uploadedImages = [];
        this.isProcessing = false;

        // 重置文本框高度
        this.$nextTick(() => {
          this.adjustTextareaHeight();
        });
      }
    },

    triggerImageUpload() {
      if (this.isProcessing) return
      this.$refs.fileInput.click();
    },
    handleImageUpload(event) {
      const files = event.target.files;

      if (!files.length) return;

      // 限制上传图片数量，最多1张
      if (this.uploadedImages.length + files.length > 1) {
        alert(this.$t('chat.maxImages'));
        return;
      }

      Array.from(files).forEach(file => {
        if (!file.type.startsWith('image/')) {
          alert(this.$t('chat.uploadTips'));
          return;
        }

        const reader = new FileReader();
        reader.onload = e => {
          this.uploadedImages.push({
            file,
            preview: e.target.result
          });
        };
        reader.readAsDataURL(file);
      });

      // 清空input，允许重复选择相同文件
      event.target.value = '';
    },
    // 清空对话并初始化到欢迎页
    clearInput() {
      if (this.isProcessing) return
      this.messages = [];
      this.userMessage = '';
      this.uploadedImages = [];
      // 重置isWelcome为true，返回到欢迎页
      this.isWelcome = true;
      this.deepThinkingEnabled = false;
      this.onlineSearchEnabled = false;

      // 重置文本框高度
      this.$nextTick(() => {
        this.adjustTextareaHeight();
      });

      console.log('对话已清空，欢迎页已显示');
    },
    removeImage(index) {
      this.uploadedImages.splice(index, 1);
    },
    showImagePreview(imageUrl) {
      this.previewImage = imageUrl;
    },
    closeImagePreview() {
      this.previewImage = null;
    },
    scrollToBottom() {
      const container = this.$refs.messagesContainer;
      if (!container) return;
      
      // 获取最后一条消息元素
      const messages = container.getElementsByClassName('message-container');
      const lastMessage = messages[messages.length - 1];
      
      if (lastMessage) {
        // 使用平滑滚动效果
        lastMessage.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'  // 滚动到消息顶部
        });
      }
    },
    // 添加新方法用于调整文本框高度
    adjustTextareaHeight() {
      const textarea = this.$refs.messageInput;

      // 重置高度以便正确计算
      textarea.style.height = 'auto';

      // 计算新高度，但不超过140px
      const newHeight = Math.min(textarea.scrollHeight, 140);
      textarea.style.height = newHeight + 'px';
    }
  }
}
</script>